import { BadgeCheck, Heart, ArrowUpRight, Rocket, Eye, Star } from "lucide-react";

const TV_URL = "https://www.tradingview.com/script/MiXDrieo-TradrQuant-Pro/";

// Real user reactions collected from Involio (rebuilt as chips for a clean, consistent look).
const REVIEWS = [
  { name: "XLC", handle: "@ayoub767", verified: true, text: "This looks good — I literally need to try it.", likes: 7 },
  { name: "Sayan", handle: "@sayan2312", text: "Real impressive stuff man. Great work.", likes: 1 },
  { name: "Pxblo", handle: "@pxblo", text: "I love it bro — keep up the insane work. 🔥", likes: 1 },
  { name: "Ryan", handle: "@ryanhorsburghh", verified: true, text: "Bro made it — he's goated.", likes: 2 },
  { name: "Vaibhav Matta", handle: "@vvaibhav_", text: "It's great, thanks a lot.", likes: 1 },
  { name: "cryptodude", handle: "@vannak", text: "It's like a strategy but you don't have to do anything? 😲", likes: 1 },
  { name: "Elitepenguin", handle: "@tim_", text: "Fireeee 🔥", likes: 1 },
];

const Chip = ({ r }) => (
  <div className="w-[280px] shrink-0 border border-white/10 bg-[#0d0d0d] hover:border-[#BACD1C]/40 transition-colors duration-300 p-4">
    <div className="flex items-center gap-2.5">
      <div className="h-7 w-7 shrink-0 flex items-center justify-center border border-white/[0.10] bg-white/[0.03] font-display font-semibold text-[#ECEBE4] text-xs">
        {r.name.charAt(0)}
      </div>
      <p className="flex items-center gap-1 font-display font-semibold tracking-[-0.03em] text-[12px] leading-none truncate">
        {r.name} {r.verified && <BadgeCheck size={12} className="text-[#BACD1C] shrink-0" />}
      </p>
      <span className="ml-auto flex items-center gap-1 shrink-0">
        <Heart size={11} className="text-[#BACD1C] fill-[#BACD1C]" />
        <span className="font-mono text-[10px] text-white/40">{r.likes}</span>
      </span>
    </div>
    <p className="mt-2.5 font-mono text-[12px] text-white/65 leading-relaxed line-clamp-2">{r.text}</p>
    <p className="mt-2 font-mono text-[9px] text-white/30">{r.handle} · via Involio</p>
  </div>
);

export const IndicatorReviews = () => {
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <section
      id="indicator-reviews"
      data-testid="indicator-reviews"
      className="relative border-t border-white/10 bg-[#080808] overflow-hidden"
    >
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 py-10">
        {/* compact header */}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-6">
          <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#B4BAC4]">
            <Star size={13} className="fill-[#BACD1C]" /> What traders are saying
          </span>
          <span className="hidden sm:inline text-white/15">/</span>
          <span className="inline-flex items-center gap-1.5 font-mono text-[11px] text-white/50"><Eye size={12} className="text-[#BACD1C]" /> 390+ views</span>
          <span className="inline-flex items-center gap-1.5 font-mono text-[11px] text-white/50"><Rocket size={12} className="text-[#BACD1C]" /> 29 boosts</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/30">· live &lt;24h</span>
          <a
            href={TV_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-tradingview-link"
            className="group ml-auto inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-[#B4BAC4] border border-white/[0.10] px-3 py-1.5 hover:bg-[#BACD1C] hover:text-black transition-colors duration-300"
          >
            On TradingView <ArrowUpRight size={12} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>

        {/* marquee */}
        <div className="tq-marquee-wrap relative [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
          <div className="tq-marquee flex gap-3">
            {loop.map((r, i) => <Chip key={i} r={r} />)}
          </div>
        </div>

        <p className="mt-3 font-mono text-[9px] text-white/25">
          // Genuine user comments from Involio, reproduced as cards.
        </p>
      </div>
    </section>
  );
};
